import { Document, Page, View } from '@react-pdf/renderer';
import styles from '../../styles';
import Header from './Header';
import { TableHeader, TableDetails } from './TableSection';
import TotalSection from './TotalSection';
import Footer from './Footer';

/**
    * CreditNoteDocument is a pure presentational component that
    * receives a fully fetched `CreditNote` object via props.
*/

const CreditNoteDocument = ({ CreditNote }) => (
    <Document>
        <Page size="A4" style={styles.page} wrap>
            {/* Header with company and CreditNote meta */}
            <Header CreditNote={CreditNote} />

            {/* Items table */}
            <View style={styles.tableContainer}>
                <TableHeader />
                <TableDetails items={CreditNote.items || []} />
            </View>

            {/* Totals and tax section */}
            <TotalSection items={CreditNote.items || []} />

            {/* Footer with terms & conditions, signatory, etc. */}
            <Footer CreditNote={CreditNote} />
        </Page>
    </Document>
);

export default CreditNoteDocument;